import React from 'react';
import footerLogo from '../images/footerlogo.svg';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {
  FaLinkedinIn,
  FaInstagram,
  FaTelegramPlane,
  FaTwitter,
  FaLinkedin,
} from 'react-icons/fa';
import { GrMedium } from 'react-icons/gr';
import LockIcon from '../icons/Lock';

import { AiOutlineReddit } from 'react-icons/ai';
import breakpoints from '../utils/breakpoints';
import { Tooltip } from 'antd';
import './styles/Footer.scss';

export default function Footer() {
  return (
    <footer>
      <div className='poolFooter-copyright'>
        <p>©2022 UniLend. All Rights Reserved.</p>
      </div>
      <div className='poolFooter-content'>
        <ul>
          <a href='https://unilend.gitbook.io/unilend-finance/' target='_blank'>
            <li>Gitbook</li>
          </a>
          <a href='https://github.com/UniLend/unilendv2' target='_blank'>
            <li>Github</li>
          </a>
          <a
            href='https://www.youtube.com/channel/UCggNiVE5EGWGHh1YwIUW7Ug'
            target='_blank'
          >
            <li>Tutorial</li>
          </a>
        </ul>
      </div>

      <div className='poolFooter-socials'>
        {/* flex 2 */}
        <ul>
          <li>
            <a
              href='https://www.linkedin.com/company/unilend-finance/'
              target='_blank'
            >
              <FaLinkedinIn size={20} className='icon' color='#0045FF' />
            </a>
          </li>
          <li>
            <a href=' https://twitter.com/UniLend_Finance' target='_blank'>
              {' '}
              <FaTwitter size={20} color='#0045FF' />
            </a>
          </li>
          <li>
            <a href='https://www.instagram.com/unilendfinance/' target='_blank'>
              {' '}
              <FaInstagram size={20} color='#0045FF' />
            </a>
          </li>
          <li>
            <a href='https://t.me/UniLendFinance' target='_blank'>
              {' '}
              <FaTelegramPlane size={20} color='#0045FF' />
            </a>
          </li>
        </ul>
      </div>

      <div className='mobile-footer'>
        <ul>
          <Link to='/'>
            {' '}
            <li className='active-tab'>Pools</li>{' '}
          </Link>
          <li>
            <span>Tokens</span>
            <LockIcon width={10} height={10} />
          </li>

          <li>
            <span>Market</span>
            <LockIcon width={10} height={10} />
          </li>
          <li>
            <span>Reward</span>
            <LockIcon width={10} height={10} />
          </li>
          <Link to='/history'>
            {' '}
            <li>Txn History</li>{' '}
          </Link>
        </ul>
      </div>
    </footer>
  );
}
